import type { Surah } from '../types';

export const surahs: Surah[] = [
  {
    id: 'al-fatihah',
    arabicName: 'الفاتحة',
    englishName: 'Al Fatihah',
    translation: 'The Opening.',
    description: 'A beautiful surah we read in every prayer.',
    listenUrl: 'https://quran.com/1',
  },
  {
    id: 'al-ikhlas',
    arabicName: 'الإخلاص',
    englishName: 'Al Ikhlas',
    translation: 'Sincerity.',
    description: 'It teaches that Allah is One.',
    listenUrl: 'https://quran.com/112',
  },
  {
    id: 'al-falaq',
    arabicName: 'الفلق',
    englishName: 'Al Falaq',
    translation: 'The Daybreak.',
    description: 'A short surah asking Allah for protection.',
    listenUrl: 'https://quran.com/113',
  },
  {
    id: 'an-nas',
    arabicName: 'الناس',
    englishName: 'An Nas',
    translation: 'Mankind.',
    description: 'A surah that reminds us Allah protects our hearts.',
    listenUrl: 'https://quran.com/114',
  },
  {
    id: 'al-kawthar',
    arabicName: 'الكوثر',
    englishName: 'Al Kawthar',
    translation: 'Abundance.',
    description: 'A tiny surah with a big gift from Allah.',
    listenUrl: 'https://quran.com/108',
  },
  {
    id: 'al-asr',
    arabicName: 'العصر',
    englishName: 'Al Asr',
    translation: 'Time.',
    description: 'It reminds us to use time well and do good.',
    listenUrl: 'https://quran.com/103',
  },
];
